import { useMutation } from '@tanstack/react-query'
import { inviteWorker, InviteWorkerRequest } from 'api/worker'
import { useInvalidatePendingInvites } from './usePendingInvites'
import { useAuthContext } from 'components/auth'

interface UseInviteWorkerMutation {
  onError?: (error: Error) => void
  onSuccess?: () => void
}

export function useInviteWorkerMutation(options?: UseInviteWorkerMutation) {
  const { company } = useAuthContext()
  const { onSuccess, ...queryOptions } = options ?? {}
  const { invalidate: invalidatePendingInvites } = useInvalidatePendingInvites()

  return useMutation({
    mutationFn: async (data: InviteWorkerRequest) => {
      if (!company?.id) {
        throw new Error('Company id not found')
      }

      return inviteWorker(company.id, data)
    },
    onSuccess() {
      invalidatePendingInvites()
      if (onSuccess) onSuccess()
    },
    ...queryOptions,
  })
}
